import { AsyncPipe, NgIf, NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output, Signal, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LimitedCurrencyAmount } from '@lx/currency/shared/model/currency.model';
import { Amount } from '@lx/shared/data-access/types';
import { BreakpointObserverService } from '@lx/shared/utils-dom';
import { InputNumberModule } from 'primeng/inputnumber';
import { Observable } from 'rxjs';
import { QTLiteStoreSignalsAdapterService } from '../../services/qt-lite-store-signals-adapter.service';
import { ImageComponent } from '@lx/quote-tool/lite/shared/ui/components';
import { PriceLabelComponent } from '@lx/quote-tool/lite/shared/ui/components';
import { WeeksCounterComponent } from '@lx/quote-tool/lite/shared/ui/components';

@Component({
  standalone: true,
  selector: 'lx-card-with-counter',
  imports: [InputNumberModule, FormsModule, WeeksCounterComponent, NgOptimizedImage, PriceLabelComponent, NgIf, AsyncPipe, NgTemplateOutlet, ImageComponent],
  templateUrl: './card-with-counter.component.html',
  styleUrls: ['./card-with-counter.component.scss'],
})
export class CardWithCounterComponent {
  @Input() title = '';
  @Input() description = '';
  @Input() imgSource = '';
  @Input() price: Amount[] | LimitedCurrencyAmount[] | undefined;
  @Input() endPrice: Amount[] | LimitedCurrencyAmount[] | undefined;
  @Input() discount = '';
  @Input() min = 0;
  @Input() max: number | undefined;
  @Input() weeks = 0;
  @Input() rightButtonDisabled = false;
  @Output() weeksChanged = new EventEmitter<number>();
  @Input() fallbackImage = '';

  currency: Signal<string | undefined>;
  isMobile$: Observable<boolean> | undefined;

  private readonly breakpointObserverService = inject(BreakpointObserverService);
  private readonly qtLiteStoreSignalsAdapterService = inject(QTLiteStoreSignalsAdapterService);

  constructor() {
    this.isMobile$ = this.breakpointObserverService.isMobile$;
    this.currency = this.qtLiteStoreSignalsAdapterService.selectedCurrency;
  }

  selectValue(weeksValue: number): void {
    this.weeks = weeksValue;
    this.weeksChanged.emit(this.weeks);
  }
}
